export default "__VITE_ASSET__c334269f__"